export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20background%20with%20warm%20amber%20and%20deep%20charcoal%20gradient%2C%20subtle%20texture%20overlay%2C%20cinematic%20lighting%20with%20soft%20glow%20accents%2C%20modern%20entertainment%20platform%20atmosphere%2C%20dramatic%20yet%20clean%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20no%20logos%2C%20abstract%20composition&width=1800&height=900&seq=hero-bg-51hl&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="bg-accent-500/20 text-accent-300 text-xs font-medium px-3 py-1 rounded-full border border-accent-500/30">
                热门吃瓜
              </span>
              <span className="bg-background-50/10 text-background-50/80 text-xs font-medium px-3 py-1 rounded-full border border-background-50/20">
                实时更新
              </span>
              <span className="bg-background-50/10 text-background-50/80 text-xs font-medium px-3 py-1 rounded-full border border-background-50/20">
                高清流畅
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-4">
              51黑料
              <span className="block text-accent-400 md:inline md:ml-3 text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
                全网热门吃瓜视频一站式平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-background-50/70 font-bold mb-5">
              最新黑料视频、吃瓜视频、娱乐八卦，尽在51黑料
            </p>

            <p className="text-sm md:text-base text-background-50/60 leading-relaxed max-w-xl mb-7">
              51黑料整合全网最新最热的黑料视频与吃瓜视频资源，覆盖明星八卦、社会热点、娱乐事件等多元内容分区。每日实时更新，为您带来第一手热门资讯。本站支持高清流畅播放，无论一区二区还是吃瓜分区，都能畅享不间断的观看体验。当前热点涵盖近期娱乐圈大事件追踪、热门综艺幕后揭秘及社会话题深度吃瓜。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-400">500+</div>
                <div className="text-xs text-background-50/50 mt-1">每日更新视频</div>
              </div>
              <div className="w-px h-10 bg-background-50/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-400">全网热点</div>
                <div className="text-xs text-background-50/50 mt-1">实时追踪覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-50/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold font-heading text-accent-400">高清流畅</div>
                <div className="text-xs text-background-50/50 mt-1">不卡顿播放体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看
              </a>
              <a
                href="#index"
                className="bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/25 px-8 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
              >
                <i className="ri-compass-3-line text-lg"></i>
                热门专区
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20entertainment%20media%20platform%20interface%20mockup%20with%20video%20thumbnails%20grid%20layout%2C%20dark%20theme%20with%20warm%20amber%20accents%2C%20sleek%20UI%20design%2C%20content%20cards%20with%20play%20buttons%2C%20trending%20video%20platform%20look%2C%20clean%20modern%20aesthetic%2C%20no%20recognizable%20people%2C%20no%20real%20brands%2C%20abstract%20content%20thumbnails&width=800&height=600&seq=hero-visual-51hl&orientation=landscape"
                alt="51黑料平台界面预览"
                className="w-full h-auto rounded-2xl"
              />
              <div className="absolute inset-0 rounded-2xl border border-background-50/10 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}